import type { components } from '../types/api/generated';
import { ffhClient } from '@lib/api/ffh-client';
import { authHeader } from '@lib/api/auth-header';

/**
 * What the member is entitled to right now, resolved by ffh-backend on every
 * call rather than read from a token, so a change of plan shows up before the
 * claims that carry it are next minted.
 */
export type MembershipEntitlements =
  components['schemas']['EntitlementsResponse']['data'];

export const fetchEntitlements = async (
  accessToken: string
): Promise<MembershipEntitlements> => {
  const { data, error } = await ffhClient().GET('/users/me/entitlements', {
    headers: authHeader(accessToken)
  });

  if (error || !data?.data) throw new Error('Failed to load entitlements');
  return data.data;
};
